import { DateUtils } from "~app/common/utils/date-utils";
import { IActivityDto } from "./aktiviteter.models";
export class ActivityViewModel {
    constructor(private readonly model: IActivityDto) {
    }

    get id() {
        return this.model.id;
    }

    get metadata() {
        return this.model.metadata;
    }

    get entityName() {
        return this.model.metadata.entityName;
    }

    get titleLong() {
        return this.model.metadata.titelLong;
    }

    get titleShort() {
        return this.model.metadata.titelShort;
    }

    get status() {
        return this.model.status;
    }

    get message() {
        return this.model.message;
    }

    get type() {
        return this.model.type;
    }

    get lastUpdated() {
        return DateUtils.formatDateString(this.model.lastUpdated, DateUtils.datetimeformatWithoutMillis);
    }
}
